import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./auth/AuthProvider";
import { App } from "./App";
import { ConfigError, loadConfig } from "./lib/config";
import "./styles.css";

const root = createRoot(document.getElementById("root")!);

try {
  const config = loadConfig();
  root.render(
    <StrictMode>
      <AuthProvider config={config}>
        <App config={config} />
      </AuthProvider>
    </StrictMode>,
  );
} catch (cause) {
  const message = cause instanceof Error ? cause.message : "Configuration invalide.";
  const missing = cause instanceof ConfigError ? cause.missing : [];
  root.render(
    <StrictMode>
      <main className="configuration-fault">
        <p className="eyebrow">Configuration requise</p>
        <h1>Le portail joueur n’est pas encore relié.</h1>
        <p>{message}</p>
        {missing.length > 0 && <code>{missing.join(" · ")}</code>}
        <small>Aucun secret ne doit être ajouté aux variables VITE_.</small>
      </main>
    </StrictMode>,
  );
}
